import {
  RECEIVE_SALE_CHANNELS_FAILURE,
  RECEIVE_SALE_CHANNELS_SUCCESS,
  REQUEST_SALE_CHANNELS,
} from './constants';

const saleChannelsReducer = (state = {
  data: [],
  isFetching: false,
}, action) => {
  switch (action.type) {
    case REQUEST_SALE_CHANNELS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_SALE_CHANNELS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case RECEIVE_SALE_CHANNELS_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default saleChannelsReducer;